(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.section-header');
        this.section?.classList.add('shopify-section-header-sticky');
        this.setHeaderHeight = this.setHeaderHeight.bind(this);
        this.setHeaderHeight();
        this.resizeObserver = new ResizeObserver(this.setHeaderHeight);
        this.resizeObserver.observe(this);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      }
    }

    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
